<template>
  <div class="message" :style="{backgroundColor: variant[type].background}">
    <time :style="{color: variant[type].time || variant.normal.time}">{{time}}</time>
    <span v-if="type == 'action'">• </span>
    <strong :style="{color: nickColor}">nickname</strong>
    <span :style="{color: variant[type].message || variant.normal.message}">
      <slot></slot>
    </span>
  </div>
</template>

<script>

export default {
  name: 'message',
  props: ['nickColor', 'variant', 'type'],
  computed: {
    time() {
      return String(new Date()).slice(16, 21)
    }
  }
}
</script>

<style scoped>
.message {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 4px 8px;
  line-height: 1.2;
  position: relative;
}

.message:hover, 
.message:hover * {
  color: white !important;
  z-index: 5;
}

.message:hover::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(153, 153, 153, 0.3);
  z-index: -1;
}

time {
  font-size: 0.75rem;
  width: 40px;
  display: inline-block;
}

.message > strong {
  margin-right: 10px;
}
</style>
